var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 13.3333V0H10.6667V8H0V32H18.6667V24H21.3333V32H37.3333V13.3333H29.3333ZM8 26.6667H5.33333V24H8V26.6667ZM8 21.3333H5.33333V18.6667H8V21.3333ZM8 16H5.33333V13.3333H8V16ZM18.6667 18.6667H16V16H18.6667V18.6667ZM18.6667 13.3333H16V10.6667H18.6667V13.3333ZM18.6667 8H16V5.33333H18.6667V8ZM24 18.6667H21.3333V16H24V18.6667ZM24 13.3333H21.3333V10.6667H24V13.3333ZM24 8H21.3333V5.33333H24V8ZM32 26.6667H29.3333V24H32V26.6667ZM32 21.3333H29.3333V18.6667H32V21.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingBlack);
export default __webpack_public_path__ + "static/media/building_black.6d11f5e1ab0664d3a9b6ecc9f2d61b3c.svg";
export { ForwardRef as ReactComponent };